import { GHL_CALENDAR_EMBED_URL } from './config';
import { getLead } from './pixel';

/* CALENDARIO GHL
 * 1) GHL → Calendars → tu calendario → Share → Embed: copia el "src" del iframe
 *    (ej: https://api.leadconnectorhq.com/widget/booking/XXXXXXXX) y pégalo en GHL_CALENDAR_EMBED_URL.
 * 2) Confirmation → "Redirect to URL": <tu-dominio>/#/confirmada
 * El calendario se abre con nombre, apellido, email y teléfono ya llenos, así la cita
 * queda en el MISMO contacto que entró en el paso 1.
 */
export function calendarSrc(): string {
  if (!GHL_CALENDAR_EMBED_URL) return '';
  const lead = getLead();
  const parts = String(lead.name || '').trim().split(/\s+/).filter(Boolean);
  const params = new URLSearchParams();
  if (parts[0]) params.set('first_name', parts[0]);
  if (parts.length > 1) params.set('last_name', parts.slice(1).join(' '));
  if (lead.name) params.set('full_name', String(lead.name).trim());
  if (lead.email) params.set('email', String(lead.email));
  if (lead.phone) params.set('phone', String(lead.phone));
  const qs = params.toString();
  if (!qs) return GHL_CALENDAR_EMBED_URL;
  return `${GHL_CALENDAR_EMBED_URL}${GHL_CALENDAR_EMBED_URL.includes('?') ? '&' : '?'}${qs}`;
}

// Script oficial de GHL: ajusta la altura del iframe automáticamente
export function loadGhlEmbedScript() {
  if (document.getElementById('ghl-form-embed')) return;
  const s = document.createElement('script');
  s.id = 'ghl-form-embed';
  s.src = 'https://link.msgsndr.com/js/form_embed.js';
  s.async = true;
  document.body.appendChild(s);
}
